var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"guess",class:[{ incorrect: _vm.guessed && !_vm.correct }, { correct: _vm.guessed && _vm.correct }],attrs:{"disabled":!_vm.liveGame || _vm.guessed},on:{"click":_vm.processGuess}},[_vm._v(_vm._s(_vm.letter))])}
var staticRenderFns = []

export { render, staticRenderFns }